import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ROUTE_PATH } from 'routes';
import { Building } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BaseSelect from './BaseSelect';

function OrganizationSelect({ platform, offset }) {
  const user = useSelector(state => state.session.user);
  const literals = useSelector(state => state.i18n.literals.startupsSelect);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const handleChange = (v) => {
    if (v.length) {
      navigate({
        pathname: ROUTE_PATH.INVESTOR_INVESTMENTS,
        search: `?organizations=${v.join(',')}`,
      });
    }
  };

  const organization = searchParams.get('organizations')?.length
    ? searchParams.get('organizations').split(',')
    : user.organizations.map(o => o.id);

  return (
    <BaseSelect
      platform={platform}
      item={organization}
      offset={offset}
      items={user.organizations}
      onChange={handleChange}
      actions={[
        {
          text: literals.manageOrganizations,
          icon: Building,
          onClick: () => navigate(ROUTE_PATH.INVESTOR_ORGANIZATIONS),
        },
      ]}
      multiple
      icon={<Building />}
      text={literals.organization}
    />
  );
}

OrganizationSelect.propTypes = {
  platform: PropTypes.object.isRequired,
  offset: PropTypes.object,
};

export default OrganizationSelect;
